import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';

const DailyQuote = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/daily-quote`);
        if (mounted) setData(res.data);
      } catch {
        if (mounted) setData(null);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  if (loading) {
    return (
      <div className="daily-quote-card daily-quote-loading" data-testid="daily-quote-loading">
        <i className="fa-solid fa-quote-left"></i>
        <span style={{ marginLeft: 12, opacity: 0.6 }}>Loading today's inspiration…</span>
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="daily-quote-card" data-testid="daily-quote">
      <div className="daily-quote-mark"><i className="fa-solid fa-quote-left"></i></div>
      <p className="daily-quote-text">{data.quote}</p>
      <div className="daily-quote-meta">
        <span>— {data.author}</span>
        <span className="daily-quote-date">{data.date}</span>
      </div>
    </div>
  );
};

export default DailyQuote;
